(function () {

    'use strict';

    angular.module('breakmarkApp').controller('CustomPaymentCtrl', ['$rootScope', '$scope', '$window', '$stateParams', '$http', 'stripe', '$templateCache', '$compile', '$timeout', function($rootScope, $scope, $window, $stateParams, $http, stripe, $templateCache, $compile, $timeout) {

        $scope.showCheckoutForm = true;
        $scope.processing = false;

        // $scope.order = {};
        $scope.order = {
            customer_name: $stateParams.customer_name,
            customer_organization:  $stateParams.customer_organization,
            customer_note: $stateParams.customer_note,
            amount: $stateParams.amount
        };

        $scope.card = {};

        $scope.sendReceiptOnly = function () {
          $scope.order.timestamp = Math.round((new Date()).getTime() / 1000)
          $scope.sendReceipts($scope.order)
        }

        $scope.formSubmit = function() {

            console.log('submitting');

            $scope.processing = true;

            angular.extend($scope.order, { timestamp: Date.now() });

            stripe.card.createToken({
                name: $scope.order.customer_name,
                number: $scope.card.number,
                cvc: $scope.card.cvc,
                exp_month: $scope.card.exp_month,
                exp_year: $scope.card.exp_year
                //zip_code:
            })
            .then(function (response) {

                console.log('received token', response);
                // console.log('which response is this', response);
                $scope.card = void 0;

                var queryString = $.param({
                  stripeToken:response.id,
                  amount: ( $scope.order.amount * 100 ), // bascially removes the decimals since stripe does amount in pennies, e.g. 500 = $5.00
                  orderInfo: 'Breakmark Custom Payment'
                });

                return $http.post('https://wt-jesse-ossium_co-0.sandbox.auth0-extend.com/stripeServer?'+queryString);

            })
            .then(function(response) {

                $scope.sendReceipts(response);

            })
            .catch(function (err) {
                if (err.type && /^Stripe/.test(err.type)) {
                    console.log('Stripe error: ', err.message);
                }
                else {
                    console.log('Non-stripe error: ', err.message);

                    alert(err.message);

                    $scope.errorResponse = err.message;

                    // $uibModal.open({
                    //     animation: true,
                    //     templateUrl:'directives/externalStore/cardError.html',
                    //     controller: function($scope, err) {
                    //
                    //         $scope.err = err;
                    //
                    //         $scope.close = function() {
                    //             $uibModalInstance.close();
                    //         }
                    //     },
                    //     resolve: {
                    //         err: function() {
                    //             return err;
                    //         }
                    //     }
                    // });
                }
            });
        } // submitForm()

        $scope.sendReceipts = (returnedOrder) => {

            console.log('sendReceipts -> order ->', returnedOrder);

            var scope = angular.extend($scope.$new(), {
                order: $scope.order,
            });

            let template = $templateCache.get('directives/externalStore/customPaymentReceiptEmailTemplate.html');

            // console.log('template -> ', template);

            let el = $compile(template)(scope);

            // console.log('message html ->', el.html());

            $timeout(function() {

                var queryString = $.param({
                  emailTo: $scope.order.customer_email,
                  emailFrom: 'Breakmark Team Store <teamstore@breakmark.com>',
                  subject: 'Custom Order',
                  message: el.html()
                });

                $http.post('https://wt-jesse-ossium_co-0.sandbox.auth0-extend.com/emailServer?'+queryString).then( (response) => {

                      // console.log('send email -> email success', response);
                      var breakmarkReceiptEmailQueryString = $.param({
                        //emailTo:'teamstore@breakmark.com,',
                        emailTo: 'sales@breakmark.com',
                        // emailTo: 'jesse@ossium.co',
                        emailFrom: 'Breakmark Team Store <teamstore@breakmark.com>',
                        subject: 'Custom Order Notification',
                        message: el.html()
                      })

                      $http.post('https://wt-jesse-ossium_co-0.sandbox.auth0-extend.com/emailServer?'+breakmarkReceiptEmailQueryString)

                      // $http.post('https://wt-jesse-ossium_co-0.sandbox.auth0-extend.com/emailServer?'+emailQueryString).then ( (response) => {
                      //   console.log('sent mail to sales@breakmark', response)
                      // }, (errorResponse) => {
                      //   console.log('could not send mail to sales@breakmark', errorResponse)
                      // });

                }, (errorResponse) => {

                    // console.log('send email -> errorResponse', errorResponse);

                    alert('There was an issue in trying to send you a receipt.');

                });

            }, 2000);

            $scope.processing = false;

            $scope.showCheckoutForm = false;

            // $state.go('singleOrder', {
            //     orderId: returnedOrder.$id,
            //     id: returnedOrder.storeId
            // });
        }
    }]);
})();
